<template>
    <div class="home-conteiner">
        <Header></Header>
        <VueSlickCarousel :arrows="true" :dots="true" :infinite="true" :autoplay="true" :autoplaySpeed="3000">
            <div v-for="(slide, i) in slides" :key="i" :style="{'background-image': 'url(' + slide.image + ')'}" class="slide-home">
                <div class="siv">
                    <img :style="{'right': slide.right}" src="@/assets/frames-slide.webp" :alt="slide.alt">
                    <div>
                        <span>{{slide.spam}}</span>
                        <h1 v-html="slide.h1"></h1>
                        <button @click="$router.push(slide.route)" class="a">{{slide.buttonA}}</button>
                        <button @click="$router.push('/connect')" class="b">{{slide.buttonB}}</button>
                    </div>
                </div>
            </div>
        </VueSlickCarousel>
        <div class="form">
            <h2>{{$t('index.formtext')}}<span>{{$t('index.spam1')}}</span>{{$t('index.formtext2')}}<span>{{$t('index.spam2')}}</span>{{$t('index.formtext3')}}</h2>
            <div id="contactForm">
                <label for="">Conoce más sobre soluciones de seguros</label>
                <div id="hubcontactForm"></div>
            </div>
            <img src="@/assets/Slide-form-1.png" alt="">
        </div>
        <div class="solution">
            <center class="service-title">
                <h1>Soluciones en seguros</h1>
            </center>
            <center class="solution-box">
                <div class="services">
                    <div class="service" @click="changeService('a')">
                        <font-awesome-icon class="facirclecheck" :class="{'active': activeA}" icon="fa-check" size="2x"/>
                        <p :class="{'activep': activeA}">Seguros ARL</p>
                    </div>
                    <div class="service" @click="changeService('b')">
                        <font-awesome-icon class="facirclecheck" :class="{'active': activeB}" icon="fa-solid fa-check" size="2x"/>
                        <p :class="{'activep': activeB}">Seguros Personales y Familia</p>
                    </div>
                    <div class="service" @click="changeService('c')">
                        <font-awesome-icon class="facirclecheck" :class="{'active': activeC}" icon="fa-solid fa-check" size="2x"/>
                        <p :class="{'activep': activeC}">Seguros Empresariales</p>
                    </div>
                </div>
                <div class="service-show" v-if="activeA" :class="{'service-effect': activeA}">
                    <center>
                        <div>
                            <img src="@/assets/Slide-Serv-1.png" alt="">
                        </div>
                        <div class="services-work">
                            <p>Seguros ARL</p>
                            <h1>Tu asesor en riesgos laborales</h1>
                            <label>Te guiamos con la responsabilidad de este proceso como complemento de tus recursos de tu ARL</label>
                        </div>
                    </center>
                </div>
                <div class="service-show" v-if="activeB" :class="{'service-effect': activeB}">
                    <center>
                        <div>
                            <img src="@/assets/Slide-Serv-2.png" alt="">
                        </div>
                        <div class="services-work">
                            <p>Seguros Personales y Familia</p>
                            <h1>Cuidando tu bienestar y transcendencia</h1>
                            <label>Servicios para tu bienestar personal y familiar, conoce como garantizamos tu protección y la de los tuyos.</label>
                        </div>
                    </center>
                </div>
                <div class="service-show" v-if="activeC" :class="{'service-effect': activeC}">
                    <center>
                        <div>
                            <img src="@/assets/Slide-Serv-3.png" alt="">
                        </div>
                        <div class="services-work">
                            <p>Seguros Empresariales</p>
                            <h1>Crece tranquilo, nosotros te respaldamos</h1>
                            <label>Cuidamos el entorno y la sostenibilidad de tu empresa.</label>
                        </div>
                    </center>
                </div>
            </center>
        </div>
        <div class="connect">
            <center>
                <img src="@/assets/bg-llamado-accion.webp" alt="">
                <h1><span>Conecta</span> con nuestros servicios </h1>
                <button @click="$router.push('/connect')">Iniciar hoy mismo</button>
            </center>
        </div>
        <div class="guarantees">
            <h1>Te garantizamos</h1>
            <div class="guarantees-list">
                <center>
                    <div class="col-lg-4" :class="col8" style="z-index: 9999;">
                            <div class="guarantee-box right">
                                <div class="img"><img src="@/assets/Icono-1.png" alt=""></div>
                                <h5>Seguridad y proteccion</h5>
                                <p>Hacemos posible tu cuidado con el respaldo de nuestros equipo.</p>
                            </div>
                    </div>
                    <div class="col-lg-4" :class="col8">
                            <div class="guarantee-box">
                                <div class="img especial"><img src="@/assets/Icono-2.png" alt=""></div>
                                <h5>Control y orden</h5>
                                <p>Puedes tener tranquilidad de nuestros servicios solicitando tu gestion en el momento que desees.</p>
                            </div>
                    </div>
                    <div class="col-lg-4" :class="col8">
                            <div class="guarantee-box left">
                                <div class="img"><img src="@/assets/Icono-3.png" alt=""></div>
                                <h5>Trascendencia y reconocimientos</h5>
                                <p>Trabajamos constantemente en hacer crecer su empresa cuidando su mejor activo. Su sueño.</p>
                            </div>
                    </div>
                </center>
            </div>
        </div>
        <div class="experiences">
            <h1>Nuestra experiencia</h1>
            <p>un sercicio enfocado a nuestros clientes, con entrega y respaldo</p>
            <div class="numbers">
                <center>
                    <div class="col-lg-3" :class="col6">
                        <center>
                            <number
                            class="number"
                            ref="number1"
                            :from="0"
                            :to="10"
                            :format="theFormat"
                            :duration="5"
                            :animationPaused="start"
                            easing="Power1.easeOut"/>
                            <label>años</label>
                            <p>de experiencia como asesores de seguros</p>
                        </center>
                    </div>
                    <div class="col-lg-3" :class="col6">
                        <center>
                            <number
                            class="number"
                            ref="number2"
                            :from="0"
                            :to="1000"
                            :format="theFormat"
                            :duration="5"
                            :animationPaused="start"
                            easing="Power1.easeOut"/>
                            <label>clientes</label>
                            <p>han confiado en nuestras asesorías para sus seguros</p>
                        </center>
                    </div>
                    <div class="col-lg-3" :class="col6">
                        <center>
                            <number
                            class="number"
                            ref="number3"
                            :from="0"
                            :to="15"
                            :format="theFormat"
                            :duration="5"
                            :animationPaused="start"
                            easing="Power1.easeOut"/>
                            <label>aseguradoras</label>
                            <p>para ofrecer las mejores tarifas y coberturas</p>
                        </center>
                    </div>
                    <div class="col-lg-3" :class="col6">
                        <center>
                            <number
                            class="number"
                            ref="number4"
                            :from="0"
                            :to="29"
                            :format="theFormat"
                            :duration="5"
                            :animationPaused="start"
                            easing="Power1.easeOut"
                            />
                            <label>seguros</label>
                            <p>para estar protegido ante todo tipo de riesgo</p>
                        </center>
                    </div>
                </center>
            </div>
        </div>
        <div class="aliados">
            <center><h1>Nuestros aliados</h1></center>
            <center>
                <VueSlickCarousel v-bind="settings">
                        <div v-for="(aliado, i) in aliados" :key="i" class="aliados-home">
                            <img :src="aliado.image" alt="" class="aliado-img">
                        </div>
                </VueSlickCarousel>
            </center>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
// import API from '@/api'
import VueSlickCarousel from 'vue-slick-carousel'
import Header from './Header/Header'
import Footer from './Footer/Footer'

export default {
    name: 'Home',
    components: {
        Header,
        VueSlickCarousel,
        Footer
    },
    data() {
        return {
            col6: 'col-sm-6',
            col8: 'col-sm-6',
            col4: 'col-sm-4',
            activeA: true,
            activeB: false,
            activeC: false,
            parallax: 2,
            parallaxFixedContent: false,
            solutionblock: false,
            height: 0,
            slides: [
                {
                    id: 'slide-1',
                    image: require('@/assets/Slide-1.webp'),
                    spam: 'Seguros ARL',
                    h1: 'Tu asesor en <br> riesgos laborales',
                    buttonA: 'Conocer más',
                    route: '/servicios/arl',
                    buttonB: 'Contacta un asesor',
                    alt: 'Tu asesor en riesgos laborales'
                },
                {
                    id: 'slide-1',
                    image: require('@/assets/Slide-2.webp'),
                    spam: 'Seguros Empresariales',
                    h1: 'Crece tranquilo, <br> nosotros te respaldamos',
                    buttonA: 'Conocer más',
                    route: '/servicios/empresas',
                    buttonB: 'Contacta un asesor',
                    alt: 'Crece tranquilo, nosotros te respaldamos'
                },
                {
                    id: 'slide-1',
                    image: require('@/assets/Slide-3.webp'),
                    spam: 'Seguros Personales y Familia',
                    h1: 'Cuidando tu bienestar <br> y transcendencia',
                    buttonA: 'Conocer más',
                    route: '/servicios/personas',
                    buttonB: 'Contacta un asesor',
                    alt: 'Cuidando tu bienestar, y transcendencia'
                }
            ],
            aliados: [
                {
                    id: 'slide1',
                    image: require('@/assets/aliados/seguros-aseguradora-solidaria.png')
                },
                {
                    id: 'slide2',
                    image: require('@/assets/aliados/seguros-axa-colpatria.png')
                },
                {
                    id: 'slide3',
                    image: require('@/assets/aliados/seguros-bmi.png')
                },
                {
                    id: 'slide4',
                    image: require('@/assets/aliados/seguros-bolivar.png')
                },
                {
                    id: 'slide5',
                    image: require('@/assets/aliados/seguros-bsb.png')
                },
                {
                    id: 'slide7',
                    image: require('@/assets/aliados/seguros-colmena.png')
                },
                {
                    id: 'slide8',
                    image: require('@/assets/aliados/seguros-del-estado.png')
                },
                {
                    id: 'slide9',
                    image: require('@/assets/aliados/seguros-global.png')
                },
                {
                    id: 'slide11',
                    image: require('@/assets/aliados/seguros-sura.png')
                },
                {
                    id: 'slide12',
                    image: require('@/assets/aliados/seguros-zurich.png')
                }
            ],
            settings: {
                'dots': false,
                'focusOnSelect': true,
                'infinite': true,
                'speed': 500,
                'slidesToShow': 4,
                'slidesToScroll': 1,
                'touchThreshold': 5,
                'autoplay': true,
                'autoplaySpeed': 3000,
                'responsive': [
                    {
                        'breakpoint': 1000,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'infinite': true,
                            'dots': false
                        }
                    },
                    {
                        'breakpoint': 600,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'initialSlide': 2
                        }
                    },
                    {
                        'breakpoint': 480,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1
                        }
                    }
                ]
            },
            fixed: '100px',
            start: true
        }
    },
    methods: {
        myEventHandler(e) {
            if (window.innerWidth < 1000) {
                this.col6 = 'col-sm-3'
                this.col8 = 'col-sm-4'
                this.col4 = 'col-sm-4'
            }
            if (window.innerWidth <= 600) {
                this.solutionblock = true
            } else {
                this.solutionblock = false
            }
        },
        theFormat(number) {
            return '+' + parseInt(number)
        },
        completed() {
            console.log('Animation ends!')
        },
        playAnimation() {
            this.$refs.number1.play()
            this.$refs.number2.play()
            this.$refs.number3.play()
            this.$refs.number4.play()
        },
        changeService(type) {
            if (type === 'a') {
                this.activeA = true
                this.activeB = false
                this.activeC = false
            }
            if (type === 'b') {
                this.activeA = false
                this.activeB = true
                this.activeC = false
            }
            if (type === 'c') {
                this.activeA = false
                this.activeB = false
                this.activeC = true
            }
        }
    },
    mounted() {
        if (window.innerWidth > 500) {
            this.height = window.innerHeight - 200
        } else {
            this.height = window.innerHeight
        }
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
        this.$root.$on('Header', (block) => {
            if (this.start === true) {
                this.playAnimation()
                this.start = false
            }
        })
    },
    created() {
        window.addEventListener('resize', this.myEventHandler)
    },
    destroyed() {
        window.removeEventListener('resize', this.myEventHandler)
    }
}
</script>

<style>
#hubcontactForm > .hs-input {
    font-family: 'JR';
}
.home-conteiner > .slick-slider > .slick-prev {
    position: absolute;
    z-index: 999999999;
    margin-left: 50px;
}
.home-conteiner > .slick-slider > .slick-next {
    position: absolute;
    z-index: 999999999;
    margin-right: 50px;
}
.home-conteiner > .slick-slider > .slick-dots {
    z-index: 99999999;
    bottom: 25px;
}
.home-conteiner > .slick-slider > .slick-dots > li > button {
    border: 5px;
    border-style: solid;
    border-radius: 50%;
    border-color: #fff;
    color: #FFF;
    background-color: #FFF;
}
.home-conteiner > .slick-slider > .slick-dots li button:hover{
    font-family: 'slick';
    font-size: 6px;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    content: '\2022';
    text-align: center;
    opacity: 0.25;
    color: black;
    -webkit-font-smoothing: antialiased;
}
.home-conteiner > .slick-slider > .slick-dots li button:active{
    background-color: #000;
}

.aliados > .slick-slider > .slick-list  {
    width: 80%;
}
</style>

<style scoped>
.slide-home {
    height: 670px;
    background-position: center;
}

.slide-home > div {
    width: 100%;
    padding: 0px;
    position: relative;
}

.slide-home > div > div {
    width: 100%;
}

.slide-home > div > img {
    height: 670px;
    position: absolute;
    right: 0;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
}

.slide-home> div > div {
    padding: 200px;
}

.slide-home > div > div > span{
    font-family: 'JBD';
    color:#65b24a;
    font-size: 32px;
}

.slide-home > div> div > h1{
    font-family: 'JBD';
    color:#FFF;
    font-size: 60px;
}

.slide-home > div > div > .a {
    font-family: 'JR';
    padding: 5px 20px 5px 20px;
    background-color: #65b24a;
    color: #fff;
    border-radius: 10px;
    font-size: 24px;
    margin-right: 15px;
    border-color: #65b24a;
    border-style: solid;
    letter-spacing: 1pt;
    margin-top: 20px;
}

.slide-home > div> div > .a:hover{
    background: rgba(0,0,0,0);
    color: #fff;
    border-radius: 10px;
    border-color: #fff;
}

.slide-home > div > div > .b {
    font-family: 'JR';
    padding: 5px 20px 5px 20px;
    background: rgba(0,0,0,0);
    color: #fff;
    border-radius: 10px;
    font-size: 24px;
    border-color: #fff;
    border-style: solid;
    letter-spacing: 1pt;
}

.slide-home > div > div > .b:hover{
    background-color: #2d4f98;
    color: #fff;
    border-color: #2d4f98;
    border-style: solid;
    letter-spacing: 1pt;
}

.form {
    font-family: 'JBD';
}

.form img{
    width: 100%;
    height: 550px;
}

.form h2 {
    position: absolute;
    padding: 200px 100px;
    width: 60%;
    color: #fff;
    font-weight: bolder;
    font-size: 35px;
    letter-spacing: 1pt;
    z-index: 9999;
}

.form h2 > span{
   color: #65b24a;
   z-index: 9999;
}

#contactForm {
    font-family: 'JR';
    background-color: #fff;
    padding: 40px;
    position: absolute;
    right: 225px;
    margin-top: 30px;
    border-radius: 10px;
    width: 400px;
    -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    font-weight: bolder;
}

.form > .form-background {
    position: absolute;
    width: 760px;
    right: 0px;
}

#contactForm > label {
    color: #65b24a;
    font-size: 24px;
    line-height: 25px;
}

.solution {
    width: 100%;
    height: auto;
}

.solution-box {
    display: flex;

}

.facirclecheck {
    font-weight: bolder;
    background-color: #aba8a8;
    color: #6a6666;
    padding: 5px;
    border-radius: 50%;
    width: 26px;
    height: 26px;
}

.active{
    background-color: #65b24a;
    color: #fff;
    -webkit-animation: checkEffect 1.0s ease-in; /* Chrome, Safari, Opera */
    animation: checkEffect 1.0s ease-in;
}

@-webkit-keyframes checkEffect {
    0% {
        background-color: #aba8a8;
        color: #6a6666;
    }
    100% {
        background-color: #65b24a;
        color: #fff;
    }
}

@keyframes checkEffect {
    0% {
        background-color: #aba8a8;
        color: #6a6666;
    }
    100% {
        background-color: #65b24a;
        color: #fff;
    }
}

.service-title {
    margin-top: 120px;
    color: #2d4f98;
    font-family: 'JBD';
}

.services {
    width: 33.33333333%;
    margin-top: 200px;
    text-align: left;
    padding-left: 230px;
}

.service {
    padding: 5px;
}

.service > .facirclecheck {
    float: left;
    margin-right: 10px;
    padding: 7px;
}

.service > p {
    margin-top: 7px;
    font-family: 'JBD';
    color: #aba8a8;
}

.service > .activep{
    color: #2d4f98;
    -webkit-animation: checkEffectP 1.0s; /* Chrome, Safari, Opera */
    animation: checkEffectP 1.0s;
}

@-webkit-keyframes checkEffectP {
    0% {
        color: #aba8a8;
    }
}

@keyframes checkEffectP {
    0% {
        color: #aba8a8;
    }
}

.service-show > center {
    width: 66.66666666666;
    display: flex;
}

.service-effect {
    -webkit-animation: serviceEffect 1.0s; /* Chrome, Safari, Opera */
    animation: serviceEffect 1.0s;
}

@-webkit-keyframes serviceEffect {
    0% {
        opacity: 0.0;
    }
    20% {
        opacity: 0.2;
    }
    40% {
        opacity: 0.4;
    }
    60% {
        opacity: 0.6;
    }
    80% {
        opacity: 0.8;
    }
    100% {
        opacity: 1;
    }
}
@keyframes serviceEffect {
    0% {
        opacity: 0.0;
    }
    20% {
        opacity: 0.2;
    }
    40% {
        opacity: 0.4;
    }
    60% {
        opacity: 0.6;
    }
    80% {
        opacity: 0.8;
    }
    100% {
        opacity: 1;
    }
}

.services-work {
    font-family: 'JR';
    text-align: left;
    margin-top: 200px;
    float: right;
    width: 300px;
}

.services-work > p{
    color: #65b24a;
    font-size: 14px;
    font-family: 'JBD';
}

.services-work > h1{
    font-family: 'JBD';
    color: #2d4f98;
}

.services-work > label{
    color: #000;
    font-size: 16px;
    font-weight: normal;
}

.lines{
    margin-top: 200px;
    right: 0;
}

hr {
    background-color: #6a6666;
    width: 5px;
    margin-left: 10px;
    height: 60px;
}

.hractive {
    background-color: #65b24a;
}

.connect {
    background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
    background: linear-gradient(to right, #2d4f98 30%, #65b24a);
    height: 200px;
    width: 100%;
}

.connect > center > img {
    position: absolute;
    height: 200px;
    width: 380px;
    right: 0;
    object-fit: cover;
    object-position: 75px -70px;
}

.connect > center h1 {
    font-family: 'JBD';
    position: absolute;
    left: 100px;
    margin-top: 90px;
    font-size: 25px;
    color: #fff;
}

.connect > center h1 span{
    color: #65b24a;
}

.connect > center button {
    font-family: 'JR';
    position: absolute;
    right: 350px;
    margin-top: 90px;
    background-color: #2d4f98;
    color: #fff;
    border-radius: 14px;
    padding: 7px 25px 7px 25px;
    border-style: none;
    font-weight: bolder;
    font-size: 18px;
    border-style: solid;
    border-color: #2d4f98;
}

.connect > center button:hover {
    background: rgba(0,0,0,0);
    color: #fff;
    border-color: #fff;
    border-style: solid;
}

.guarantees h1 {
    text-align: center;
    margin-top: 120px;
    color: #2d4f98;
    font-family: 'JBD';
}

.guarantees {
    background-color: #fff;
    padding-bottom: 50px;
}

.guarantees-list center{
    display: flex;
    margin-top: 50px;
}

.guarantee {
    width: 100px;
    float: left;
    padding: auto;
    margin: auto;
}

.guarantee-box {
    width: 300px;
    height: 300px;
    background: linear-gradient(0deg,rgba(39,153,246,.08),hsla(0,0%,100%,.04));
    transition: background 0.5s ease-out 100ms;
    transition: margin-top 0.5s ease-out 100ms;
    transition: box-shadow 0.5 ease-out 100ms;
    padding: 10px;
}

.guarantee-box:hover {
    background: #fff;
    margin-top: -10px;
    -webkit-box-shadow: 10px 5px 15px 0px rgba(0,0,0,0.07);
    -moz-box-shadow: 10px 5px 15px 0px rgba(0,0,0,0.07);
    box-shadow: 10px 5px 15px 0px rgba(0,0,0,0.07);
}

.right {
    margin-right: -60%;
}

.left {
    margin-left: -60%;
}

.img{
    width: 80px;
    height: auto;
    background: linear-gradient(to bottom right, #65b24a, #2d4f98);
    padding: 20px 20px 20px 20px;
    border-radius: 50%;
    -webkit-box-shadow: 0px 7px 20px 0px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 7px 20px 0px rgba(0,0,0,0.15);
    box-shadow: 0px 7px 20px 0px rgba(0,0,0,0.15);
}

.especial {
    background: linear-gradient(to bottom right, #45f133, #336ff0);
}

.img > img{
    width: 40px;
}

.guarantee-box > h5 {
    font-family: 'JR';
    padding-top: 15px;
    color: #2d4f98;
    font-weight: bold;
}

.guarantee-box > p {
    font-family: 'JR';
    padding-top: 10px;
}

.experiences {
    width: 100%;
    background-image: url('../assets/testimonial-bg.455fa17a.webp');
    background-size: cover;
    padding-bottom: 60px;
    padding-top: 60px;
}

.experiences > h1 {
    text-align: center;
    font-family: 'JBD';
    color: #fff;
}

.experiences > p {
    margin-top: 10px ;
    text-align: center;
    font-family: 'JR';
    color: #fff;
}

.numbers > center {
    margin-top: 50px;
    display: flex;
}

.numbers > center > div > center > p {
    width: 200px;
}

.numbers > center > div > center > p {
    color:#fff;
    font-family: 'JR';
}

.numbers > center > div > center > label {
    color:#fff;
    font-family: 'JBD';
    display: block;
    text-transform: uppercase;
}

.number {
    color: #65b24a;
    font-family: 'JBD';
    font-size: 50px;
}

.aliados {
    padding-top: 100px;
    padding-left: 50px;
    padding-right: 50px;
}

.aliados-home > .aliado-img{
    margin-top: 25px;
    margin-bottom: 25px;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
}

.aliados > center > h1 {
    font-family: 'jbd';
    color: #2d4f98;
    margin-bottom: 35px;
}

.slide-aliados img {
    width: 250px;
    height: auto;
    align-items: center;

}

.slide-aliados {
    background-color: #fff;
    padding-top: 10px;
    margin-bottom: 100px;
}

@media (max-width: 1300px) {
    .services{
        padding-left: 10%;
        margin-top: 130px;
    }
    .service-show > div > img{
        width: 90%;
    }
    .service-show > .services-work, .services, .lines {
        margin-top: 130px;
    }
    .form h2 {
       width: 50%;
    }
    .right {
        margin-right: -50%;
    }

    .left {
        margin-left: -50%;
    }
}

@media (max-width: 1200px) {
    .right {
        margin-right: -35%;
    }

    .left {
        margin-left: -35%;
    }
}

@media (max-width: 1100px) {
    .form h2 {
        width: 50%;
        font-size: 30px;
    }
    #contactForm {
        padding: 20px;
        right: 150px;
    }
    .services{
        padding-left: 50px;
        margin-top: 130px;
    }
    .service-show > div > img{
        width: 400px;
    }
    .service-show > center> .services-work {
        margin-top: 130px;
        width: 250px;
    }
    .form > .form-background {
        width: 650px;
    }
    .connect > center > button {
        right: 250px;
    }
    .right {
        margin-right: -18%;
    }
    .left {
        margin-left: -18%;
    }
}

@media (max-width: 1000px) {
    .form h2 {
        width: 50%;
        font-size: 25px;
        letter-spacing: 1pt;
    }
    #contactForm {
        padding: 20px;
        right: 100px;
        width: 350px;
    }
    .form > .form-background {
        width: 550px;
    }
    .services{
        padding-left: 50px;
        margin-top: 130px;
    }
    .service-show > center > div > img{
        width: 400px;
    }
    .service-show > center> .services-work{
        margin-top: 130px;
    }
    .connect > center > button {
        right: 150px;
    }
    .col-sm-6 {
        flex: 0 0 35%;
    }
    .guarantee-box {
        width: 250px;
    }
    .right {
        margin-right: 1%;
    }

    .left {
        margin-left: 1%;
    }
}

@media (max-width: 900px) {
    .form h2 {
        width: 50%;
        font-size: 25px;
        letter-spacing: 1pt;
        margin-top: -60px;
    }
    #contactForm {
        padding: 20px;
        right: 100px;
        width: 300px;
    }
    .form > .form-background {
        width: 500px;
    }
    .services {
        padding-left: 10px;
        width: 33.33333%;
    }
    .service-show >center> div > img{
        width: 350px;
    }
    .service-show > center> .services-work, .services {
        margin-top: 50px;
    }
    .services-work > h1{
       font-size: 25px;
    }
    .service > .facirclecheck {
        float: left;
        margin-right: 5px;
        padding: 3px;
        width: 20px;
    }
    .connect > center h1 {
        left: 75px;
    }
    .connect > center > button {
        right: 75px;
    }
    .right {
        margin-right: 0px;
    }
    .left {
        margin-left: 0px;
    }
    .numbers > center {
        margin-top: 50px;
        display: block;
    }
    .numbers > center > div > center  {
        width: 500px;
    }
    .col-sm-3 {
        max-width: 100%;
    }
    .numbers > center > div > center > span {
        width: auto;
    }
    .numbers > center > div > center > label {
        margin-top: -15px;
        width: auto;
        font-size: 25px;
    }
    .numbers > center > div > center > p {
        width: auto;
    }
    .col-sm-6 {
        flex: 0 0 35%;
    }
    .aliados {
        padding-left: 200px;
        padding-right: 200px;
    }
}

@media (max-width: 800px) {
    .slide-home > div > div > span {
        font-size: 25px;
    }
    .slide-home > div > div > h1 {
        font-size: 45px;
    }
    .slide-home > div > div > .a {
        font-size: 18px;
    }
    .slide-home > div > div > .b {
        font-size: 18px;
    }
    .service-show > center> div > img{
        width: 350px;
    }
    .service-show > center > .services-work, .services {
        margin-top: 15px;
        width: 200px;
    }
    .services-work >center> h1{
       font-size: 25px;
    }
    .service > .facirclecheck {
        float: left;
        margin-right: 5px;
        padding: 3px;
        width: 20px;
        height: 20px;
    }
    .connect > center h1 {
        left: 50px;
    }
    .connect > center > button {
        right: 50px;
    }
    .guarantees-list center {
        display: block;
    }
    .guarantee-box {
        margin-bottom: 30px;
    }
    .col-sm-6 {
        flex: 0 0 35%;
    }
    .col-sm-4 {
        max-width: 100%;
    }
    .aliados {
        padding-left: 100px;
        padding-right: 100px;
    }
}

@media (max-width: 700px) {
    .slide-home> div > div {
        padding: 150px;
        padding-top: 200px;
    }
    .form h2 {
        width: 45%;
        font-size: 20px;
        letter-spacing: 0pt;
        margin-top: -120px;
        padding: 200px 50px;
    }

    #contactForm {
        padding: 20px;
        right: 50px;
        width: 300px;
    }
    .form > .form-background {
        width: 420px;
    }
    .service-show > center > div > img{
        width: 300px;
    }
    .service-show > .services-work, .services, .lines {
        width: 150px;
    }
    .service-show > center > .services-work {
       width: 150px;
    }
    .services-work > h1{
       font-size: 25px;
    }
    .service > .facirclecheck {
        float: left;
        margin-right: 5px;
        padding: 3px;
        width: 20px;
    }
    .connect > center h1 {
        left: 30px;
        font-size: 25px;
    }
    .connect > center > button {
        right: 30px;
        font-size: 15px;
    }
    .col-sm-6 {
        flex: 0 0 35%;
    }
    .aliados {
        padding-left: 30px;
        padding-right: 30px;
    }
}

@media (max-width: 600px) {
    .slide-home> div > div {
        padding: 120px;
        padding-top: 200px;
    }
    .form {
        height: 600px;
    }

    .form h2 {
        width: 100%;
        font-size: 20px;
        letter-spacing: 0pt;
        margin-top: -120px;
        padding: 175px 50px;
    }

    #contactForm {
        padding: 20px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        width: 400px;
        margin-top: 150px;
    }
    .form > .form-background {
        margin-top: 120px;
        width: 600px;
    }
    .solution-box {
        display: block;
    }
    .services {
        width: 80%;
        display: flex;
    }
    .solution-box > .lines {
        width: 80%;
        margin-top: 0px;
        display: flex;
        padding-left: 6%;
        margin-top: -20px;
    }
    .solution-box > .lines > hr {
        width: 60px;
        margin-left: 10px;
        height: 5px;
    }
    .hractive {
        background-color: #65b24a;
    }
    .service-show > div > img{
        width: 300px;
    }
    .service-show > .services-work {
        margin-top: 15px;
    }
    .services-work > h1{
       font-size: 25px;
    }
    .service > .facirclecheck {
        float: left;
        margin-right: 5px;
        padding: 3px;
        width: 20px;
    }
    .service > p {
        display: block;
    }
    .connect > center h1 {
        left: 30px;
        font-size: 25px;
        width: 300px;
    }
    .connect > center > button {
        right: 30px;
        font-size: 15px;
    }
    .col-sm-6 {
        flex: 0 0 35%;
    }
    .aliados {
        padding-left: 30px;
        padding-right: 30px;
    }
    .numbers > center > div > center  {
        width: 400px;
    }
}

@media (max-width: 500px) {
    .slide-home> div > div {
        padding: 90px;
        padding-top: 200px;
    }
    .slide-home > div > div > span {
        font-size: 18px;
    }
    .slide-home > div > div > h1 {
        font-size: 38px;
    }
    .slide-home > div > div > .a {
        font-size: 11px;
    }
    .slide-home > div > div > .b {
        font-size: 11px;
    }
    #contactForm {
        width: 300px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
    }
    .form > .form-background {
        width: 500px;
    }
    .connect > center h1 {
        left: 0px;
        font-size: 20px;
        width: 250px;
        position: relative;
        margin-top: 30px;
        padding-top: 30px;

    }
    .connect > center > button {
        right: 0px;
        font-size: 15px;
        position: relative;
        margin-top: 20px;
    }
    .service-show > center{
        display: block;
    }
    .service-show > center .services-work{
        float: none;
        width: 90%;
    }
}

@media (max-width: 440px) {
    .numbers > center > div > center  {
        width: 200px;
    }
}

@media (max-width: 400px) {
    .slide-home> div > div {
        padding: 60px;
        padding-top: 250px;
    }
    .form h2 {
        margin-bottom: 60px;
    }
    #contactForm {
        margin-top: 190px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        width: 300px;
    }
    .service-title {
        margin-top: 150px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue